import { View as LibView } from "@tamagui/core";
const View = LibView;
View.displayName = "View";
export { View };
//# sourceMappingURL=View.mjs.map
